
import { Component, Vue } from 'vue-property-decorator'
import VenueList from '@/components/company/venue/VenueList.vue'

@Component({
  name: 'venues',
  components: { VenueList }
})
class Venues extends Vue {}

export default Venues
